export default __webpack_public_path__ + "static/media/accommodation-highlight.0046524e.svg";